module.exports = __webpack_public_path__ + "img/Elorejelzes_novenyvedelem_ikon.fc64c621.png";